import { CountryFlagIcon } from "@msuite/ui/country-flag-icon";
import { Select, Textarea } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import { locales } from "@msuite/utils/locales";
import React from "react";
import { useFormContext } from "react-hook-form";
import { useMentionOptions } from "@/hooks/use-mention-options";

export function SuggestBetterTranslationForm() {
	/** Context */
	const methods = useFormContext();
	const mentionOptions = useMentionOptions();

	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<React.Fragment>
			<Select
				isRequired
				control={methods.control}
				name="language"
				label="Sprache"
				isNullable={false}
				options={locales.map(
					(locale) =>
						({
							value: locale,
							label: locale,
							item: { locale },
						}) as const,
				)}
				renderOption={(item) => (
					<div className="h-stack">
						<CountryFlagIcon locale={item.locale} />
						<p>{t(`localization.${item.locale}`)}</p>
					</div>
				)}
				itemNotFoundLabel={undefined}
			/>
			<Textarea
				label={t("localization.current_translation")}
				isRequired
				control={methods.control}
				name="current"
				disableFormatting
				members={[]}
				projects={[]}
				mentionRenderers={mentionOptions.mentionRenderers}
			/>
			<Textarea
				label={t("localization.suggested_translation")}
				isRequired
				control={methods.control}
				name="suggestion"
				disableFormatting
				members={[]}
				projects={[]}
				mentionRenderers={mentionOptions.mentionRenderers}
			/>
			<p className="label">{t("localization.suggest_better_translation_description")}</p>
		</React.Fragment>
	);
}
